/**
 * Generates an SEO and screen-reader friendly alt text for images based on a title string.
 * @param {string} title - The title or descriptive text to format
 * @param {string} fallback - The fallback alt text if the title is empty or null
 * @returns {string} The formatted alt text string
 */
export const generateImageAltText = (title, fallback = "Image") => {
  if (!title || typeof title !== "string") {
    return fallback;
  }

  // Trim whitespace, remove special characters that might be weird in alt tags, and format it nicely
  const sanitizedTitle = title.trim().replace(/['"]/g, "");

  if (!sanitizedTitle) {
    return fallback;
  }

  return `Thumbnail for ${sanitizedTitle}`;
};
